var _defs, _polyline, _polyline2, _polyline3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1179({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "1 7.3 8 2.07 15 7.3"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "13.59 8.19 13.59 13.93 10.26 13.93 10.26 10.6 5.74 10.6 5.74 13.93 2.41 13.93 2.41 8.19"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "4.55 2.59 2.31 2.59 2.31 4.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1179);
export default __webpack_public_path__ + "static/media/Symbolpack_1_179.3fcef0ed1238c026f6a891f7856fd829.svg";
export { ForwardRef as ReactComponent };